export enum SecurityClass {
  Debt = 'D',
  Equity = 'E',
}

export enum SecurityType {
  DebtMortgage = 'D-Mortgage',
  DebtOther = 'D-Other',
  DebtSenior = 'D-Senior',
  DebtSub = 'D-Sub',
  EquityCommon = 'E-Common',
  EquityOther = 'E-Other',
  EquityPref = 'E-Pref',
}
